import { gql } from '@apollo/client';

export * from './escrowMemberUpdate.mutation.generated';

export const ESCROW_MEMBER_UPDATE = gql`
  mutation escrowMemberUpdate($input: EscrowMemberUpdateInput!) {
    escrowMemberUpdate(input: $input) {
      errors
      success
      escrowMember {
        ...EscrowMemberFragment
      }
    }
  }
`;
